export default "__VITE_ASSET__BukZ21ow__"